import { Serializable } from '../../../core/models/serializable';
import { PortfolioAccountManagerModel } from './portfolio-account-manager-model';

export class PortfolioAddModel implements Serializable<PortfolioAddModel> {
  fromObject(object: any): PortfolioAddModel {
    Object.assign(this, object);
    return this;
  }

  toObject() {
    throw new Error('Method not implemented.');
  }

  public name: string;
  public comment: string;
  public accountManagerId: number;

  constructor() {}
}
